/* Built In Imports */
import React, { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import LeftNavCommonUI from '@components/UI/Common/LeftNavCommonUI';
import YogaCommonUI from '@components/UI/Yoga/YogaCommonUI';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';
import { AuthContext } from '@store/auth-context';

/* Services */
import {
    getLocale
} from '@components/Utility/Shared/SharedService';
import {
    fetchFooterData, fetchHeaderMenuData, fetchHeaderTopMenuData
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/yogaService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Health Landing Page Data
 */
const YogaMeditationAdditionalProgramInner = ({
  region,
  language,
  pageData,
}) => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang(region, language);
  }, [authContext, region, language]);
  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData?.breadcrumbs}
        alsoin={pageData?.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <Box
        as="section"
        className="page-wrap container-article"
        padding={{ base: '15px', md: '0' }}
      >
        <YogaCommonUI
          pageBody={pageData.body}
          region={region}
          lang={language}
        />
        <LeftNavCommonUI
          pageBody={pageData.bodyLeftNavSections}
          region={region}
          lang={language}
          isLeftMenu
        />
        <YogaCommonUI
          pageBody={pageData.bodyBottomSection}
          region={region}
          lang={language}
        />
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const yogaLandingPaths = config.USE_LOCAL_URL
    ? [
        `/in/en/yoga-meditation/additional-programs/shakti-chalana-kriya/terms-and-conditions-uk`,
      ]
    : await getLandingPaths('L3', '/additional-programs/', [
        '/additional-programs/shivanga-sadhana/',
        '/additional-programs/shivanga-sadhana-pc/',
      ]);
  // consoleLog('yogaLandingPaths', yogaLandingPaths);
  return {
    paths: yogaLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language, program, programInner },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(
    region,
    language,
    `additional-programs/${program}/${programInner}`, { preview, data: previewData }
  );

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false
    }
  };
};

export default YogaMeditationAdditionalProgramInner;
